module.exports = __webpack_public_path__ + "static/media/sage-kirk-485982-unsplash.41262f78.jpg";